import { useEffect } from 'react';

interface SplashProps {
  onFinish: () => void;
}

export default function Splash({ onFinish }: SplashProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onFinish();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50">
      <div className="flex flex-col items-center px-4">
        <img
          src="/logo.png"
          alt="梅花易道书院"
          className="w-full max-w-[529px] aspect-[529/367] object-contain animate-fade-in"
        />
      </div>
    </div>
  );
}
